<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

/*滚动条设置*/
*::-webkit-scrollbar {
  width: 12px;
  background-color: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background: #d9d8d8;
  border-radius: 6px;
}

*::-webkit-scrollbar-thumb:hover {
  background: #bfbebe;
}

a {
  text-decoration: none;
}

a,
input,
button {
  outline: none;
}

li {
  list-style: none;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
  /* background-color: #333D47; */
  font-family: "microsoft yahei", Helvetica, Tahoma, Arial, "Microsoft jhengHei",
    sans-serif;
}

html {
  height: 100%;
  margin: 0;
  padding: 0;
  /* background-color: #333D47; */
  overflow-x: hidden;
}

.buy_menu .ivu-menu-vertical .ivu-menu-item:hover,
.buy_menu .ivu-menu-vertical .ivu-menu-submenu-title:hover {
  /* background: #1296db; */
  /* color: #ffffff; */
}

/*Content中企业产品的样式*/
.EnterPriseAll {
  width: 100%;
  height: 260px;
  display: flex;
  display: -webkit-flex;
  place-items: center;
  overflow: hidden;
  cursor: pointer;
  border-radius: 5px;
}

.EnterPriseAll:hover img {
  transition: 1.5s;
  -webkit-transition: 1.5s;
  -moz-transition: 1.5s;
  transform: scale(1.5);
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
}

.EnterPriseAll img {
  width: 100%;
  height: 100%;
}

/*导航菜单的样式*/
.MenuItemSpan {
  font-size: 18px;
  font-family: 微软雅黑, serif;
  font-weight: bold;
  color: black;
}

/*把导航下面的横线取消*/
.buy_menu .ivu-menu-vertical.ivu-menu-light:after {
  height: 0;
}

/*去掉百度地图的图标*/
.BMap_cpyCtrl {
  display: none;
}

.anchorBL {
  display: none;
}

/*------关于我们--------*/
.res_div {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}

.font_size {
  font-size: 16px;
  font-family: 微软雅黑, serif;
  line-height: 34px;
}

.div_img {
  border-radius: 42px;
  width: 150px;
  font-size: 32px;
  font-family: 微软雅黑, serif;
  border: 1px solid #65b3e9;
  color: #65b3e9;
  padding: 6px;
  margin: 20px 0 0 340px;
}

.div_img:hover {
  cursor: pointer;
  background: #65b3e9;
  border: 1px solid #65b3e9;
  color: #fff;
  position: relative;
}

/*-----------------------*/
</style>



// WEBPACK FOOTER //
// src/App.vue